<script setup>
defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], required: true },
  trend: { type: String, default: '' },
  trendDirection: {
    type: String,
    default: 'neutral',
    validator: v => ['up', 'down', 'neutral'].includes(v),
  },
  valueColor: { type: String, default: '' },
  loading: { type: Boolean, default: false },
});

const trendClass = direction => {
  if (direction === 'up') return 'text-n-teal-11';
  if (direction === 'down') return 'text-n-ruby-11';
  return 'text-n-slate-9';
};
</script>

<template>
  <div
    class="bg-n-solid-2 border border-n-weak rounded-[10px] p-4 transition-colors hover:border-n-strong"
  >
    <div
      class="text-[11px] font-medium uppercase tracking-wider text-n-slate-9 mb-2"
    >
      {{ label }}
    </div>
    <!-- Skeleton state -->
    <template v-if="loading">
      <div class="animate-pulse">
        <div class="h-7 w-16 bg-n-solid-3 rounded mx-auto mb-1.5" />
        <div class="h-3 w-24 bg-n-solid-3 rounded mx-auto" />
      </div>
    </template>
    <!-- Data state -->
    <template v-else>
      <div
        class="text-2xl font-bold leading-tight text-n-slate-12"
        :class="valueColor"
      >
        {{ value }}
      </div>
      <div
        v-if="trend"
        class="text-xs font-medium mt-1"
        :class="trendClass(trendDirection)"
      >
        {{ trend }}
      </div>
    </template>
  </div>
</template>
